import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { CookieSettingsLink } from "@/components/CookieBanner";
import { rutaCondiciones, rutaPrivacidad } from "@/lib/legalPaths";

const PRIVACIDAD: Record<string, string> = {
  es: "Política de privacidad",
  en: "Privacy policy",
  pt: "Política de privacidade",
  fr: "Politique de confidentialité",
};

const CONDICIONES: Record<string, string> = {
  es: "Condiciones de contratación",
  en: "Terms and conditions",
  pt: "Condições de contratação",
  fr: "Conditions générales",
};

/** Enlaces legales del pie de página: política de privacidad, condiciones y ajustes de cookies */
export const LegalLinks = ({ className = "" }: { className?: string }) => {
  const { language } = useLanguage();
  return (
    <>
      <Link to={rutaPrivacidad(language)} className={`underline underline-offset-4 ${className}`}>
        {PRIVACIDAD[language] || PRIVACIDAD.es}
      </Link>
      {" · "}
      <Link to={rutaCondiciones(language)} className={`underline underline-offset-4 ${className}`}>
        {CONDICIONES[language] || CONDICIONES.es}
      </Link>
      {" · "}
      <CookieSettingsLink className={className} />
    </>
  );
};
